import { ROUTES } from "Scenes/constants"
import { Redirect, Route, Switch } from "react-router-dom"
const { PREFABS } = ROUTES

const PrefabsScene = function({ path }) {
  return (
    <Route path={path}>
      <Switch>
        <Route path={path}>
          <h1>All Prefabs</h1>
        </Route>
        <Redirect
          exact
          to={`${path}/${PREFABS}`}
        />
      </Switch>
    </Route>
  )
}

export default PrefabsScene
